import React from 'react'
import { array } from 'prop-types'
import { useMediaPredicate } from 'react-media-hook'
import { DEVICE } from '../../util/constants'

import * as Styled from './styles/EventListingBlock.styles'
import { formatCityAndState } from '../../util/strings'
import {
  formatShortDate,
  getShortDayOfWeek,
  futureEvents,
} from '../../util/timeDateUtils'
import CtaLink from './CtaLink'

export const EventRow = ({ event, isLast }) => {
  const tabletAndUp = useMediaPredicate(DEVICE.tabletL)
  const cityStateString = formatCityAndState(
    event.event_city,
    event.event_state
  )
  return (
    <>
      <Styled.EventListingFlexContainer>
        <Styled.EventDateFlexContainer>
          {!event.end_date && (
            <Styled.EventListingDateBox>
              <span>{getShortDayOfWeek(event.event_date)}</span>
              <span>{formatShortDate(event.event_date)}</span>
            </Styled.EventListingDateBox>
          )}
          {event.end_date && (
            <Styled.EventListingMultiDateBox>
              <span>{formatShortDate(event.event_date)}</span>
              <span>to</span>
              <span>{formatShortDate(event.end_date)}</span>
            </Styled.EventListingMultiDateBox>
          )}
          {event.event_image?.url && (
            <img src={event.event_image.url} alt={event.event_image.alt} />
          )}
        </Styled.EventDateFlexContainer>
        <Styled.EventTextRegion>
          <h2>{event.event_title?.text ?? ''}</h2>
          <p>{event.event_description?.text ?? ''}</p>
          {tabletAndUp && (
            <CtaLink
              text={
                event.event_link_text
                  ? event.event_link_text
                  : 'Learn More About This Event'
              }
              link={event.event_link}
            />
          )}
        </Styled.EventTextRegion>
        <Styled.EventDetailsFlexContainer>
          <h3>When</h3>
          <p>
            {event.start_time}
            {event.end_time && ` to ${event.end_time}`}
          </p>
          <h3>Where</h3>
          {event.event_venue && <p>{event.event_venue}</p>}
          {event.event_address_line_1 && <p>{event.event_address_line_1}</p>}
          {event.event_address_line_2 && <p>{event.event_address_line_2}</p>}
          {cityStateString && <p>{cityStateString}</p>}
        </Styled.EventDetailsFlexContainer>
      </Styled.EventListingFlexContainer>
      {!tabletAndUp && (
        <CtaLink
          text={
            event.event_link_text
              ? event.event_link_text
              : 'Learn More About This Event'
          }
          link={event.event_link}
          additionalStyles={Styled.additionalCtaStyles}
        />
      )}
      {!isLast && <Styled.DividerRow />}
    </>
  )
}

const EventListing = ({ data, bottomPaddingAdjustment }) => {
  const events = futureEvents(
    data.filter(e => !!e.event?.document?.data).map(e => e.event)
  )

  return (
    <Styled.EventListingBlock bottomPaddingAdjustment={bottomPaddingAdjustment}>
      {events.map(
        (event, index) =>
          event && (
            <EventRow
              key={event.id}
              event={event.document.data}
              isLast={index >= events.length - 1}
            />
          )
      )}
    </Styled.EventListingBlock>
  )
}

export default EventListing
